import React, { Component } from 'react';
import ScheduleOne from './scheduleOne';
import ScheduleTwo from './scheduleTwo';
import ScheduleThree from './scheduleThree';
import ScheduleFour from './scheduleFour';

class ScheduleMain extends Component {
  state = {
    progress: 1,
    schedule: {
      days: [],
      times: [],
      type: '',
      frequency: '',
      startDate: '',
      note: '',
      card: {
        name: '',
        number: '',
        csv: '',
        expiry: '',
      },
    },
  };

  handleInput = ({ currentTarget }) => {
    const { type, id, value } = currentTarget;

    if (type === 'radio')
      return this.setState({
        schedule: { ...this.state.schedule, [id]: value },
      });

    if (type === 'checkbox') {
      const customId = currentTarget.getAttribute('data-id');
      const schedule = { ...this.state.schedule };

      const found = schedule[id].find((obj) => {
        return obj.label === customId;
      });

      if (found) {
        const index = schedule[id].indexOf(found);

        schedule[id].splice(index, 1);

        this.setState({ schedule });

        return;
      }
      schedule[id].push({ label: customId, value: value });
      this.setState({ schedule });
      return;
    }

    const schedule = { ...this.state.schedule };
    schedule[id] = value;
    this.setState({ schedule });
    console.log(this.state.schedule);
  };

  handleNext = () => {
    const { progress } = this.state;
    this.setState({ progress: progress + 1 });
  };

  handlePrev = () => {
    const { progress } = this.state;
    this.setState({ progress: progress - 1 });
  };

  render() {
    const { onInput } = this.props;
    const { progress } = this.state;
    return (
      <React.Fragment>
        {progress === 1 && (
          <ScheduleOne
            {...this.props}
            onNext={this.handleNext}
            onPrev={this.handlePrev}
            onInput={onInput}
          />
        )}
        {progress === 2 && (
          <ScheduleTwo
            {...this.props}
            onNext={this.handleNext}
            onPrev={this.handlePrev}
            onInput={this.handleInput}
          />
        )}
        {progress === 3 && (
          <ScheduleThree
            {...this.props}
            onNext={this.handleNext}
            onPrev={this.handlePrev}
            onInput={this.handleInput}
          />
        )}
        {progress === 4 && (
          <ScheduleFour
            {...this.props}
            onNext={this.handleNext}
            onPrev={this.handlePrev}
            onInput={this.handleInput}
          />
        )}
      </React.Fragment>
    );
  }
}

export default ScheduleMain;
